
<div class="e-input-group x-disabled" 
[ngClass]="{'e-disabled': !enabled, 'e-float-input': label && label !== ''}" #editButton
[formGroup]='model' style="width: 100%">
        <ng-container *ngIf="!multiline else multilineBlock">

                <input class="e-input x-disabled" type="text"
        
                (blur)='focusOut(editButton)'   
                style="width: 100%"
                value='{{value}}'
                (focus)='focusIn(editButton)' [ngClass]="{'e-disabled': !enabled}"
                placeholder="{{placeholder}}" [formControlName]="'value'" [readonly]="readonly" />
        
                <label class="ex-manual-float-label" *ngIf='label'>{{label}}</label>
        
                <span class="e-input-group-icon fal fa-times" 
                *ngIf="clearable && model.get('value')?.value"
                (mouseup)="onMouseUp(editButton)" (mousedown)="onMouseDown(editButton)" (click)='clear()'></span>
                
                <span class="e-input-group-icon fas fa-ellipsis-h" 
                (mouseup)="onMouseUp(editButton)" (mousedown)="onMouseDown(editButton)" (click)='onClicked()'></span>

        </ng-container>

        <ng-template #multilineBlock>
                <textarea class="e-input x-disabled" type="text"
                [rows]="lines"
                (blur)='focusOut(editButton)'   
                style="width: 100%"
                value='{{value}}'
                (focus)='focusIn(editButton)' [ngClass]="{'e-disabled': !enabled}"
                placeholder="{{placeholder}}" [formControlName]="'value'" [readonly]="readonly">
                </textarea>
        
                <label class="ex-manual-float-label" *ngIf='label'>{{label}}</label>
        
                <span class="e-input-group-icon fal fa-times" 
                *ngIf="clearable && model.get('value')?.value"
                (mouseup)="onMouseUp(editButton)" (mousedown)="onMouseDown(editButton)" (click)='clear()'></span>

                <span class="e-input-group-icon fas fa-ellipsis-h" 
                (mouseup)="onMouseUp(editButton)" (mousedown)="onMouseDown(editButton)" (click)='onClicked()'></span>


        </ng-template>

</div>